import React from 'react';
import './styles.less';
import { useTracker } from 'utils/tracking';
import centerImage from 'assets/ttu/end-center.avif';
import bgImage from 'assets/ttu/end-bg.avif';
import bgImageMobile from 'assets/ttu/end-bg-mobile.avif';
import { Button } from 'components';
import { useWindowSize } from 'usehooks-ts';
import { withLayout } from 'helpers';

function End({ history, nextRoute }) {
  const isMobile = useWindowSize().width <= 768;
  const trackOnce = useTracker();

  function onNext() {
    trackOnce('lead_question19_Congrats_Proceed_to_schedule');
    history.push(nextRoute);
  }

  return (
    <div className="misc2-container">
      <div className="content">
        <div className="inner">
          <img className="circleimage" src={centerImage} />

          <div className="title_container banner_container">
            <h1 className="label statement_title">Congratulations!</h1>

            <h1 className="label statement_title">
              Based on your responses, Nue Life could be a great fit for you.
            </h1>

            <h2 className="label statement_subtitle">
              Let's set up your account to book a call with our welcome team!
            </h2>

            <Button className="schedule" onClick={onNext}>
              Proceed to schedule
            </Button>
          </div>
        </div>
        <img className="bgimage" src={isMobile ? bgImageMobile: bgImage} />
      </div>

      <span className="yellowtbg" />
    </div>
  );
}

End.title = "Congratulations! | Nue Life";

export default withLayout(End);